/* Shared UI primitives — aligned with the family portal design. */

export const ICONS = {
  lock: <><rect x="4" y="10" width="16" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3" /></>,
  shield: <><path d="M12 3l8 3v5c0 5-3.4 8.5-8 10-4.6-1.5-8-5-8-10V6z" /><path d="M9 12l2 2 4-4" /></>,
  forms: <><path d="M8 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-2" /><rect x="8" y="2" width="8" height="4" rx="1" /><path d="M8 11h8M8 15h5" /></>,
  users: <><circle cx="9" cy="8" r="3.4" /><path d="M2.5 20c0-3.4 2.9-5 6.5-5s6.5 1.6 6.5 5" /><path d="M16 5.2a3.4 3.4 0 0 1 0 6.6M18 20c0-2.6-1-4.2-2.6-5" /></>,
  chevronRight: <><path d="M9 6l6 6-6 6" /></>,
};

export function Icon({ name, className, style }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      style={style}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {ICONS[name]}
    </svg>
  );
}

const BRAND = process.env.PUBLIC_URL + "/brand";
const MARK_SRC = {
  amber: BRAND + "/stride-mark-amber.png",
};
const WORDMARK_SRC = {
  white: BRAND + "/stride-wordmark-white.png",
};

export function Mark({ size = 40, variant = "amber" }) {
  return (
    <img
      className="brand-img"
      src={MARK_SRC[variant] || MARK_SRC.amber}
      alt="Stride Early Learning"
      style={{ width: size, height: size }}
    />
  );
}

export function Logo({ variant = "white", height = 40 }) {
  return (
    <img
      className="brand-img"
      src={WORDMARK_SRC[variant] || WORDMARK_SRC.white}
      alt="Stride Early Learning"
      style={{ height }}
    />
  );
}

export function BlobField() {
  const shapes = [
    { cls: "blob", c: "var(--orange)", w: 320, h: 300, top: "-90px", left: "-70px", o: 0.5 },
    { cls: "blob-b", c: "var(--amber)", w: 200, h: 220, bottom: "8%", right: "-60px", o: 0.45 },
    { cls: "blob-c", c: "var(--orange)", w: 150, h: 160, bottom: "-50px", left: "22%", o: 0.35 },
  ];
  return (
    <div aria-hidden="true" className="blob-field">
      {shapes.map((s, i) => (
        <div
          key={i}
          className={s.cls}
          style={{
            width: s.w,
            height: s.h,
            background: s.c,
            opacity: s.o,
            top: s.top,
            left: s.left,
            right: s.right,
            bottom: s.bottom,
          }}
        />
      ))}
    </div>
  );
}

export function Button({ variant = "primary", block, iconRight, className = "", children, ...rest }) {
  const cls = ["btn", `btn-${variant}`, block ? "btn-block" : "", className].filter(Boolean).join(" ");
  return (
    <button className={cls} {...rest}>
      {children}
      {iconRight && <Icon name={iconRight} className="ico-16" />}
    </button>
  );
}
